import React from "react";
import { zekayStaticBranding } from "../config/staticFiles";

export function useZekayAuthMark() {
  const src = React.useMemo(() => zekayStaticBranding.zekayIconPng(), []);
  const onImgError = React.useCallback(() => {}, []);
  return { src, onImgError };
}
